import { Wrapper } from "./DataSecurityMobile.style";
import box from "../../../../public/image/whyUs/mobile/datasecurity/box.webp";
import arrow from "../../../../public/image/whyUs/mobile/datasecurity/arrow.webp";
import eye from "../../../../public/image/whyUs/mobile/datasecurity/eye.webp";
import lock from "../../../../public/image/whyUs/mobile/datasecurity/lock.webp";
import zipper from "../../../../public/image/whyUs/mobile/datasecurity/zipper.webp";
import logo from "../../../../public/image/whyUs/mobile/datasecurity/logo.webp";
import Footer from "../../../Footer/Footer";
import { useRef } from "react";

const DataSecurity = ({ active }) => {
  const wrap = useRef();

  const content = [
    {
      title: "A Trustworthy Partnership",
      icon: lock.src,
      paragraph: `In terms of corporate code of conduct, the <span class="darkblue bold">“LMS”</span> model guarantees your business a trustworthy partnership guided by a compliance culture that encompasses corporate employees statements, employment rights, and anti-bribery acts.<br><br>The guidelines we follow are <span class="bold">reviewed and validated by various global organizations, aligning with corporate compliance best practices and reinforced by technical documentation</span>.`,
      color: "#11112F",
    },
    {
      title: "Market-Based Compliance",
      icon: box.src,
      paragraph: `A sustainable, long-term partnership awaits your business for all its manpower sourcing needs through our regulatory compliance to local laws in every market we operate in.<br><br>Such compliance practices are <span class="bold">governed by a <span style="white-space: nowrap"">cross-auditing</span> validation model and empowered by a market-based compliance and legal expertise.</span>`,
      color: "#3A82A6",
    },
    {
      title: "Exclusive Account Management Model",
      icon: eye.src,
      paragraph: `Our exclusive account management model ensures a regulated management of each partner’s account to <span class="bold">exclude any conflicts of interest and provide strict data confidentiality.</span><br><br>The model dedicates resources and professional capabilities to meet the specific business requirements of each account as a standalone, extended business unit.`,
      color: "#DA4E1B",
    },
    {
      title: "Structured Confidentiality Guidelines",
      icon: arrow.src,
      paragraph: `Complete <span class="bold">data privacy, security, and confidentiality</span> are guaranteed by the <span class="darkblue">“LMS”</span> model that adopts structured confidentiality guidelines and data privacy codes according to the global standards.<br><br>Such confidentiality is reinforced by non-solicitation agreements signed by all associated internal stakeholders, and the data security management is supported by <span class="bold">three-layered security servers</span>.`,
      color: "#00928B",
    },
    {
      title: "Global Digital Security Standards",
      icon: zipper.src,
      paragraph: `Such <span class="bold">IT infrastructure</span> aligns with the global digital security standards and complies with the digital due diligence criteria of various multinational organizations, and it is certified and audited by the security centers of global organizations in <span class="bold">UK, Switzerland, Denmark, Singapore,</span> and numerous other locations.`,
      color: "#FDF48E",
    },
  ];

  return (
    <Wrapper secHeight={active ? wrap.current?.clientHeight : 0}>
      <div className="security" ref={wrap}>
        <div className="security__header">
          <img src={logo.src} alt="" />
        </div>
        <div className="security__content">
          <div className="security__content__sectionWrapper">
            {content.map((item, index) => (
              <section key={index}>
                <div className="security__content__sectionWrapper__head">
                  <div className="security__content__sectionWrapper__head__title">{item.title}</div>
                  <div className="security__content__sectionWrapper__head__icon">
                    <img className="security__content__sectionWrapper__icon__iconImage" src={item.icon} alt="" />
                  </div>
                  <div className="security__content__sectionWrapper__head__color" style={{ backgroundColor: item.color }}></div>
                </div>
                <div className="security__content__sectionWrapper__paragraph" dangerouslySetInnerHTML={{ __html: item.paragraph }}></div>
              </section>
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </Wrapper>
  );
};

export default DataSecurity;
